class FreightRequestForm {
    constructor() {
        this.self = $(document).find('#request-a-freight');
        this.form = this.self.find('form');

        this.injectProductData();
    }

    injectProductData() {
        let product = this.self.attr('data-product');

        let labels = this.form.find('label');

        labels.each((index, item) => {
            let text = $(item).text().trim();

            if (text === 'Product *') {
                $(item).hide();
                $(item).next('input').val("Product: " + product).attr('type','hidden');
            }
        });
    }

    clickBtn() {
      console.log(123)
    }
}

$(document).on('ready', () => {
    window.FreightRequestForm = new FreightRequestForm();
});



// WEBPACK FOOTER //
// ./resources/js/FreightRequestForm.js